import { InputWrapperProps } from '@mantine/core';
import { Controller, useFormContext } from 'react-hook-form';
import { PrivateInformationFormSchemaType } from '../../hooks/usePrivateInformationFormSchema';
import { BirthdateInput } from './components';

type BirthdateInputFieldProps = InputWrapperProps;

export const BirthdateInputField: React.FC<BirthdateInputFieldProps> = ({
  ...props
}) => {
  const { control } = useFormContext<PrivateInformationFormSchemaType>();

  return (
    <Controller
      control={control}
      name="birthdate"
      render={({ field: { value, onChange } }) => (
        <BirthdateInput value={value} setValue={onChange} {...props} />
      )}
    />
  );
};
